const local = {
  info: {
    REACT_APP_WEBSITE_URL: "https://www.agentgrc.ai",
  },
  bookdemo: {
    Link: "https://demo.elixirdata.co/",
  },
};

const dev = {
  auth: {
    REACT_APP_AUTH_URL: "https://akira-ai-auth.stage.neuralcompany.team/api/auth",
  },
  app: {
    WORKSPACE_DOMAIN_NAME: ".neuralcompany.team",
  },
  info: {
    REACT_APP_WEBSITE_URL: "https://www.agentgrc.ai",
  },
  bookdemo: {
    Link: "https://demo.elixirdata.co/",
  },
};

const prod = {
  auth: {
    REACT_APP_AUTH_URL: "https://app.akira.ai/api/auth",
  },
  app: {
    WORKSPACE_DOMAIN_NAME: ".akira.ai",
  },
  info: {
    REACT_APP_WEBSITE_URL: "https://www.agentgrc.ai",
  },
  bookdemo: {
    Link: "https://demo.elixirdata.co/",
  },
};

const config =
  process.env.REACT_APP_STAGE === "production"
    ? prod
    : process.env.REACT_APP_STAGE === "development"
    ? dev
    : local;

// eslint-disable-next-line
export default {
  ...config,
};
